var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperclip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.285 9H17.715C12.255 9 9 12.255 9 17.715V30.27C9 35.745 12.255 39 17.715 39H30.27C35.73 39 38.985 35.745 38.985 30.285V17.715C39 12.255 35.745 9 30.285 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3005 32.4899C23.2505 32.4899 22.1855 32.0849 21.3905 31.2899C19.7855 29.6849 19.7855 27.0599 21.3905 25.4549L23.5055 23.3399C23.9405 22.9049 24.6605 22.9049 25.0955 23.3399C25.5305 23.7749 25.5305 24.4949 25.0955 24.9299L22.9805 27.0449C22.2455 27.7799 22.2455 28.9649 22.9805 29.6999C23.7155 30.4349 24.9005 30.4349 25.6355 29.6999L28.9655 26.3699C29.8805 25.4549 30.3905 24.2249 30.3905 22.9199C30.3905 21.6149 29.8805 20.3999 28.9655 19.4699C27.1205 17.6249 23.9105 17.6249 22.0655 19.4699L18.4355 23.0999C16.8755 24.6599 16.8755 27.2099 18.4355 28.7849C18.8705 29.2199 18.8705 29.9399 18.4355 30.3749C18.0005 30.8099 17.2805 30.8099 16.8455 30.3749C14.4005 27.9299 14.4005 23.9549 16.8455 21.5099L20.4755 17.8799C21.8255 16.5299 23.6105 15.7949 25.5155 15.7949C27.4205 15.7949 29.2055 16.5299 30.5555 17.8799C31.9055 19.2299 32.6405 21.0149 32.6405 22.9199C32.6405 24.8249 31.9055 26.6099 30.5555 27.9599L27.2255 31.2899C26.4155 32.0849 25.3655 32.4899 24.3005 32.4899Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.40b826582ee1cf1b0ce0ab32739667c8.svg";
export { ForwardRef as ReactComponent };